<div class="select-box-container" [ngClass]="config?.classes">
  <label *ngIf="config?.label" class="select-box-label">{{ config.label | translate }}</label>

  <mat-select [value]="config?.value" [placeholder]="config?.placeholder" [disabled]="config?.disabled"
    [multiple]="config?.multiple" [tabIndex]="config?.tabIndex" (selectionChange)="onSelectionChange($event.value)"
    class="select-box-select">

    <mat-option *ngFor="let option of config?.options" [value]="option.value" [disabled]="option.disabled">
      {{ option.label }}
    </mat-option>
  </mat-select>

  <div *ngIf="currentErrorMessage" class="select-box-error">
    {{ currentErrorMessage }}
  </div>
</div>